
const isProductionEnvironment = () => window.location.host == 'homemover.azurewebsites.net' || window.location.host == 'move.propertybutton.ie';

const isStagingEnvironment = () => window.location.host == 'homemover-staging.azurewebsites.net' || window.location.host == 'move-staging.propertybutton.ie';


const isAzureDomain = () => window.location.host.includes(".azurewebsites.net");
export {isProductionEnvironment, isStagingEnvironment, isAzureDomain }